(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetailStatistics', {
            templateUrl: 'app/score-detail/score-detail-statistics/score-detail-statistics.component.html',
            controller: ScoreDetailStatisticsComponent,
            bindings: { data: '<' }
        });

    var isNumber = angular.isNumber;

    ScoreDetailStatisticsComponent.$inject = ['$filter'];
    function ScoreDetailStatisticsComponent($filter) {
        var ctrl = this,
            percentFilter = $filter('percentage'),
            isNullFilter = $filter('isnull');

        ctrl.girChart = null;
        ctrl.$onInit = init;

        function init() {
            ctrl.girChart = createGirChart();
            ctrl.firChart = createFirChart();
            ctrl.recoveryData = createRecoveryData();
        }

        function createGirChart() {
            var data = ctrl.data;
            var isInvalid = data.girHit == null || data.girOpp == null;
            if (isInvalid) {
                data.girHit = data.girOpp = data.girPercent = null;
            }
            var isEmpty = isInvalid || (!data.girHit && !data.girOpp);
            return {
                labels: ['Hit', 'Miss', 'N/A'],
                data: [data.girHit, data.girOpp - data.girHit, isEmpty ? 1 : 0],
                colors: ['#97BBCD', '#DCDCDC', '#CCCCCC'],
                options: createOptions(isEmpty)
            }
        }
        function createFirChart() {
            var data = ctrl.data;
            var isInvalid = data.firHit == null || data.firOpp == null;
            if (isInvalid) {
                data.firHit = data.firOpp = data.firHit = data.firLong = data.firRight = data.firShort = data.firLeft = data.firOther = null;
            }
            var isEmpty = isInvalid || (!data.firHit && !data.firLong && !data.firRight && !data.firShort && !data.firLeft && !data.firOther);
            return {
                labels: ['Hit', 'Long', 'Right', 'Short', 'Left', 'Other', 'N/A'],
                data: [data.firHit, data.firLong, data.firRight, data.firShort, data.firLeft, data.firOther, isEmpty ? 1 : 0],
                colors: ['#97BBCD', '#DCDCDC', '#F7464A', '#46BFBD', '#FDB45C', '#949FB1', '#CCCCCC'],
                options: createOptions(isEmpty)
            };
        }
        function createOptions(isEmpty) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: { enabled: !isEmpty },
                hover: { mode: !isEmpty ? 'nearest' : null }
            };
        }

        function createRecoveryData() {
            var data = ctrl.data;

            return [
                ['Up/Down', data.upDownPercent, data.upDownHit, data.upDownOpp],
                ['Sand Save', data.sandSavePercent, data.sandSaveHit, data.sandSaveOpp],
                ['Scrambling', data.scramblePercent, data.scrambleHit, data.scrambleOpp],
                ['Bounce Back', data.bounceBackPercent, data.bounceBackHit, data.bounceBackOpp]
            ].map(function (x) { return { name: x[0], value: value(x[1]), description: description(x[2], x[3]) } });

            function value(percent) {
                return isNullFilter(percentFilter(percent, 0), 'N/A');
            }

            function description(hit, opp) {
                return isNumber(hit) && isNumber(opp) ? hit + ' of ' + opp : ' ';
            }
        }
    }
})();